import { FiChevronDown } from '@react-icons/all-files/fi/FiChevronDown';
import clsx from 'clsx';
import { CSSProperties, ReactNode, useContext, useEffect, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { LocaleContext } from './rebrand/Layout';

const FaqItem = ({
  arrowColor = 'blue',
  className,
  children,
  styleBtn,
  styleFaqItemContent,
  styleTitle,
  title,
}: {
  arrowColor?: string;
  className?: string;
  children: ReactNode;
  styleBtn?: string;
  styleFaqItemContent?: string;
  styleTitle?: string;
  title: string;
}) => {
  const locale = useContext(LocaleContext);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [tags, setTags] = useState<(HTMLAnchorElement | HTMLButtonElement)[]>([]);

  const labelBtn = {
    en: `Toggle faq item ${title}`,
    fr: `Basculer l'article de la FAQ ${title}`,
  }[locale];

  const refFaqItemContent = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (refFaqItemContent && refFaqItemContent.current) {
      const anchorTags = Array.from(refFaqItemContent.current.querySelectorAll('a'));
      const buttonTags = Array.from(refFaqItemContent.current.querySelectorAll('button'));
      setTags([...anchorTags, ...buttonTags]);
    }
  }, [refFaqItemContent]);

  useEffect(() => {
    if (tags.length > 0) {
      tags.forEach((tag) => tag.setAttribute('tabindex', isOpen ? '0' : '-1'));
    }
  }, [tags, isOpen]);

  return (
    <div className={twMerge(clsx('mb-32 border-b-2 border-b-[#dfdfdf]', className))}>
      <button
        tabIndex={0}
        aria-label={labelBtn}
        onClick={() => setIsOpen(!isOpen)}
        className={twMerge(clsx('flex w-full cursor-pointer items-center justify-between py-8', styleBtn))}
      >
        <h4
          className={twMerge(
            clsx('mb-0 mr-32 min-h-[1.5em] text-start text-md font-bold leading-150 md:text-lg', styleTitle),
          )}
        >
          {title}
        </h4>
        <FiChevronDown
          className={twMerge(
            clsx(
              'shrink-0 rotate-0 text-3xl text-[var(--faq-chevron-color)] transition-transform duration-[0.3s] ease-in',
              isOpen && 'rotate-180',
            ),
          )}
          style={{ '--faq-chevron-color': arrowColor } as CSSProperties}
        />
      </button>
      <div
        className={twMerge(
          clsx(
            'pointer-events-none max-h-0 translate-x-20 opacity-0 transition-all duration-[0.3s] ease-out',
            isOpen && 'opacity-1 pointer-events-auto max-h-1000 transform-none',
          ),
        )}
      >
        <div className={twMerge(clsx('py-32', styleFaqItemContent))} ref={refFaqItemContent}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default FaqItem;
